// extracted by mini-css-extract-plugin
module.exports = {"gradientBorderOptions":"MarketDropdown_gradientBorderOptions__16gnv","gradientBorderPerps":"MarketDropdown_gradientBorderPerps__hmQMV"};